import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    launcher: 'Support',
    title: 'Support',
    subtitle: 'We answer within a day',
    close: 'Close',
    emptyTitle: 'No messages yet',
    emptyText: 'Tell us what happened — we will sort it out.',
    placeholder: 'What happened?',
    send: 'Send',
    attach: 'Attach',
    attachCamera: 'Camera',
    attachPhoto: 'Photo',
    attachFile: 'File',
    removeFile: 'Remove',
    fileTooBig: 'The file is over 5 MB — pick a smaller one',
    sending: 'Sending',
    sendFailed: 'Did not go through. Try again',
    blocked: 'You cannot write to support right now.',
    needsPayment: 'Support chat opens after your first top-up. Make a payment and write to us.',
    loadOlder: 'Load earlier messages',
    loadError: 'Could not load the conversation',
    retry: 'Try again',
    operator: 'Support',
    system: 'SHOT',
    download: 'Download',
    fileUnavailable: 'The file did not open',
    sticker: 'Sticker',
    contact: 'Contact',
    contactNoPhone: 'no number',
    location: 'Location',
    poll: 'Poll',
    unsupported: 'A “{{kind}}” message',
    openChat: 'Write to support',
    kindText: 'Message',
    kindPhoto: 'Photo',
    kindVideo: 'Video',
    kindVideoNote: 'Video message',
    kindVoice: 'Voice message',
    kindAudio: 'Audio',
    kindDocument: 'File',
    kindSticker: 'Sticker',
    kindAnimation: 'GIF',
    kindContact: 'Contact',
    kindLocation: 'Location',
    kindPoll: 'Poll',
    kindOther: 'Message',
  },
  ru: {
    launcher: 'Поддержка',
    title: 'Поддержка',
    subtitle: 'Отвечаем в течение суток',
    close: 'Закрыть',
    emptyTitle: 'Пока тут пусто',
    emptyText: 'Напиши, что случилось, — разберёмся.',
    placeholder: 'Что случилось?',
    send: 'Отправить',
    attach: 'Прикрепить',
    attachCamera: 'Камера',
    attachPhoto: 'Фото',
    attachFile: 'Файл',
    removeFile: 'Убрать',
    fileTooBig: 'Файл больше 5 МБ — выбери поменьше',
    sending: 'Отправляю',
    sendFailed: 'Не ушло. Попробуй ещё раз',
    blocked: 'Писать в поддержку сейчас нельзя.',
    needsPayment: 'Чат с поддержкой открывается после первого пополнения. Пополни счёт — и пиши.',
    loadOlder: 'Показать, что было раньше',
    loadError: 'Не получилось загрузить переписку',
    retry: 'Ещё раз',
    operator: 'Поддержка',
    system: 'SHOT',
    download: 'Скачать',
    fileUnavailable: 'Файл не открылся',
    sticker: 'Стикер',
    contact: 'Контакт',
    contactNoPhone: 'номер не передан',
    location: 'Геометка',
    poll: 'Опрос',
    unsupported: 'Сообщение вида «{{kind}}»',
    openChat: 'Написать в поддержку',
    kindText: 'Сообщение',
    kindPhoto: 'Фото',
    kindVideo: 'Видео',
    kindVideoNote: 'Кружок',
    kindVoice: 'Голосовое',
    kindAudio: 'Аудио',
    kindDocument: 'Файл',
    kindSticker: 'Стикер',
    kindAnimation: 'Гифка',
    kindContact: 'Контакт',
    kindLocation: 'Геометка',
    kindPoll: 'Опрос',
    kindOther: 'Сообщение',
  },
  uz: {
    launcher: 'Qoʻllab-quvvatlash',
    title: 'Qoʻllab-quvvatlash',
    subtitle: 'Bir kun ichida javob beramiz',
    close: 'Yopish',
    emptyTitle: 'Hozircha boʻsh',
    emptyText: 'Nima boʻlganini yoz — hal qilamiz.',
    placeholder: 'Nima boʻldi?',
    send: 'Yuborish',
    attach: 'Biriktirish',
    attachCamera: 'Kamera',
    attachPhoto: 'Rasm',
    attachFile: 'Fayl',
    removeFile: 'Olib tashlash',
    fileTooBig: "Fayl 5 MB dan katta — kichikrogʻini tanla",
    sending: 'Yuborilyapti',
    sendFailed: 'Yuborilmadi. Yana urin',
    blocked: 'Hozir qoʻllab-quvvatlashga yozib boʻlmaydi.',
    needsPayment: 'Qoʻllab-quvvatlash chati birinchi toʻlovdan keyin ochiladi. Hisobni toʻldir — va yoz.',
    loadOlder: 'Oldingi xabarlarni koʻrsatish',
    loadError: 'Yozishmalarni yuklab boʻlmadi',
    retry: 'Yana',
    operator: 'Qoʻllab-quvvatlash',
    system: 'SHOT',
    download: 'Yuklab olish',
    fileUnavailable: 'Fayl ochilmadi',
    sticker: 'Stiker',
    contact: 'Kontakt',
    contactNoPhone: 'raqam yoʻq',
    location: 'Joylashuv',
    poll: 'Soʻrovnoma',
    unsupported: '«{{kind}}» turidagi xabar',
    openChat: 'Qoʻllab-quvvatlashga yozish',
    kindText: 'Xabar',
    kindPhoto: 'Rasm',
    kindVideo: 'Video',
    kindVideoNote: 'Video xabar',
    kindVoice: 'Ovozli xabar',
    kindAudio: 'Audio',
    kindDocument: 'Fayl',
    kindSticker: 'Stiker',
    kindAnimation: 'GIF',
    kindContact: 'Kontakt',
    kindLocation: 'Joylashuv',
    kindPoll: 'Soʻrovnoma',
    kindOther: 'Xabar',
  },
  fa: {
    launcher: 'پشتیبانی',
    title: 'پشتیبانی',
    subtitle: 'تا یک روز جواب می‌دهیم',
    close: 'بستن',
    emptyTitle: 'هنوز پیامی نیست',
    emptyText: 'بگو چه شده — درستش می‌کنیم.',
    placeholder: 'چه اتفاقی افتاده؟',
    send: 'بفرست',
    attach: 'پیوست',
    attachCamera: 'دوربین',
    attachPhoto: 'عکس',
    attachFile: 'فایل',
    removeFile: 'حذف',
    fileTooBig: 'فایل بیشتر از 5 مگابایت است — کوچک‌ترش را بفرست',
    sending: 'در حال ارسال',
    sendFailed: 'ارسال نشد. دوباره تلاش کن',
    blocked: 'الان نمی‌توانی به پشتیبانی پیام بدهی.',
    needsPayment: 'چت پشتیبانی بعد از اولین شارژ باز می‌شود. پرداخت کن و برایمان بنویس.',
    loadOlder: 'پیام‌های قبلی را بیاور',
    loadError: 'گفتگو باز نشد',
    retry: 'دوباره تلاش کن',
    operator: 'پشتیبانی',
    system: 'SHOT',
    download: 'دانلود',
    fileUnavailable: 'فایل باز نشد',
    sticker: 'استیکر',
    contact: 'مخاطب',
    contactNoPhone: 'بدون شماره',
    location: 'موقعیت',
    poll: 'نظرسنجی',
    unsupported: 'پیام «{{kind}}»',
    openChat: 'به پشتیبانی بنویس',
    kindText: 'پیام',
    kindPhoto: 'عکس',
    kindVideo: 'ویدیو',
    kindVideoNote: 'پیام ویدیویی',
    kindVoice: 'پیام صوتی',
    kindAudio: 'صدا',
    kindDocument: 'فایل',
    kindSticker: 'استیکر',
    kindAnimation: 'گیف',
    kindContact: 'مخاطب',
    kindLocation: 'موقعیت',
    kindPoll: 'نظرسنجی',
    kindOther: 'پیام',
  },
  pt: {
    launcher: 'Suporte',
    title: 'Suporte',
    subtitle: 'Respondemos em até um dia',
    close: 'Fechar',
    emptyTitle: 'Ainda não tem nada aqui',
    emptyText: 'Conte o que aconteceu — a gente resolve.',
    placeholder: 'O que aconteceu?',
    send: 'Enviar',
    attach: 'Anexar',
    attachCamera: 'Câmera',
    attachPhoto: 'Foto',
    attachFile: 'Arquivo',
    removeFile: 'Remover',
    fileTooBig: 'O arquivo passa de 5 MB — escolha um menor',
    sending: 'Enviando',
    sendFailed: 'Não foi. Tente de novo',
    blocked: 'Não dá para escrever para o suporte agora.',
    needsPayment: 'O chat com o suporte abre depois do primeiro depósito. Deposite — e escreva.',
    loadOlder: 'Mostrar mensagens anteriores',
    loadError: 'Não deu para carregar a conversa',
    retry: 'De novo',
    operator: 'Suporte',
    system: 'SHOT',
    download: 'Baixar',
    fileUnavailable: 'O arquivo não abriu',
    sticker: 'Figurinha',
    contact: 'Contato',
    contactNoPhone: 'sem número',
    location: 'Localização',
    poll: 'Enquete',
    unsupported: 'Mensagem do tipo “{{kind}}”',
    openChat: 'Escrever para o suporte',
    kindText: 'Mensagem',
    kindPhoto: 'Foto',
    kindVideo: 'Vídeo',
    kindVideoNote: 'Vídeo curto',
    kindVoice: 'Áudio de voz',
    kindAudio: 'Áudio',
    kindDocument: 'Arquivo',
    kindSticker: 'Figurinha',
    kindAnimation: 'GIF',
    kindContact: 'Contato',
    kindLocation: 'Localização',
    kindPoll: 'Enquete',
    kindOther: 'Mensagem',
  },
  tr: {
    launcher: 'Destek',
    title: 'Destek',
    subtitle: 'Bir gün içinde yanıtlıyoruz',
    close: 'Kapat',
    emptyTitle: 'Burası şimdilik boş',
    emptyText: 'Ne olduğunu yaz — hallederiz.',
    placeholder: 'Ne oldu?',
    send: 'Gönder',
    attach: 'Ekle',
    attachCamera: 'Kamera',
    attachPhoto: 'Fotoğraf',
    attachFile: 'Dosya',
    removeFile: 'Kaldır',
    fileTooBig: "Dosya 5 MB'tan büyük — daha küçük bir dosya seç",
    sending: 'Gönderiliyor',
    sendFailed: 'Gitmedi. Tekrar dene',
    blocked: 'Şu an desteğe yazamazsın.',
    needsPayment: 'Destek sohbeti ilk bakiye yüklemesinden sonra açılır. Bakiye yükle — ve yaz.',
    loadOlder: 'Önceki mesajları göster',
    loadError: 'Yazışma yüklenemedi',
    retry: 'Tekrar',
    operator: 'Destek',
    system: 'SHOT',
    download: 'İndir',
    fileUnavailable: 'Dosya açılmadı',
    sticker: 'Çıkartma',
    contact: 'Kişi',
    contactNoPhone: 'numara yok',
    location: 'Konum',
    poll: 'Anket',
    unsupported: '“{{kind}}” türünde mesaj',
    openChat: 'Desteğe yaz',
    kindText: 'Mesaj',
    kindPhoto: 'Fotoğraf',
    kindVideo: 'Video',
    kindVideoNote: 'Video mesaj',
    kindVoice: 'Sesli mesaj',
    kindAudio: 'Ses',
    kindDocument: 'Dosya',
    kindSticker: 'Çıkartma',
    kindAnimation: 'GIF',
    kindContact: 'Kişi',
    kindLocation: 'Konum',
    kindPoll: 'Anket',
    kindOther: 'Mesaj',
  },
  uk: {
    launcher: 'Підтримка',
    title: 'Підтримка',
    subtitle: 'Відповідаємо протягом доби',
    close: 'Закрити',
    emptyTitle: 'Поки тут порожньо',
    emptyText: 'Напиши, що сталося, — розберемося.',
    placeholder: 'Що сталося?',
    send: 'Надіслати',
    attach: 'Прикріпити',
    attachCamera: 'Камера',
    attachPhoto: 'Фото',
    attachFile: 'Файл',
    removeFile: 'Прибрати',
    fileTooBig: 'Файл більший за 5 МБ — обери менший',
    sending: 'Надсилаю',
    sendFailed: 'Не надіслалось. Спробуй ще раз',
    blocked: 'Зараз писати в підтримку не можна.',
    needsPayment: 'Чат із підтримкою відкривається після першого поповнення. Поповни рахунок — і пиши.',
    loadOlder: 'Показати, що було раніше',
    loadError: 'Не вдалося завантажити листування',
    retry: 'Ще раз',
    operator: 'Підтримка',
    system: 'SHOT',
    download: 'Завантажити',
    fileUnavailable: 'Файл не відкрився',
    sticker: 'Стікер',
    contact: 'Контакт',
    contactNoPhone: 'номер не передано',
    location: 'Геопозиція',
    poll: 'Опитування',
    unsupported: 'Повідомлення типу «{{kind}}»',
    openChat: 'Написати в підтримку',
    kindText: 'Повідомлення',
    kindPhoto: 'Фото',
    kindVideo: 'Відео',
    kindVideoNote: 'Відеоповідомлення',
    kindVoice: 'Голосове',
    kindAudio: 'Аудіо',
    kindDocument: 'Файл',
    kindSticker: 'Стікер',
    kindAnimation: 'Гіфка',
    kindContact: 'Контакт',
    kindLocation: 'Геопозиція',
    kindPoll: 'Опитування',
    kindOther: 'Повідомлення',
  },
  de: {
    launcher: 'Support',
    title: 'Support',
    subtitle: 'Wir antworten innerhalb eines Tages',
    close: 'Schließen',
    emptyTitle: 'Noch keine Nachrichten',
    emptyText: 'Schreib uns, was passiert ist – wir klären das.',
    placeholder: 'Was ist passiert?',
    send: 'Senden',
    attach: 'Anhängen',
    attachCamera: 'Kamera',
    attachPhoto: 'Foto',
    attachFile: 'Datei',
    removeFile: 'Entfernen',
    fileTooBig: 'Die Datei ist größer als 5 MB – wähle eine kleinere',
    sending: 'Wird gesendet',
    sendFailed: 'Hat nicht geklappt. Versuch es nochmal',
    blocked: 'Du kannst dem Support gerade nicht schreiben.',
    needsPayment: 'Der Support-Chat öffnet sich nach deiner ersten Aufladung. Lade auf und schreib uns.',
    loadOlder: 'Frühere Nachrichten laden',
    loadError: 'Der Verlauf konnte nicht geladen werden',
    retry: 'Nochmal',
    operator: 'Support',
    system: 'SHOT',
    download: 'Herunterladen',
    fileUnavailable: 'Die Datei ließ sich nicht öffnen',
    sticker: 'Sticker',
    contact: 'Kontakt',
    contactNoPhone: 'keine Nummer',
    location: 'Standort',
    poll: 'Umfrage',
    unsupported: 'Eine „{{kind}}“-Nachricht',
    openChat: 'Dem Support schreiben',
    kindText: 'Nachricht',
    kindPhoto: 'Foto',
    kindVideo: 'Video',
    kindVideoNote: 'Videonachricht',
    kindVoice: 'Sprachnachricht',
    kindAudio: 'Audio',
    kindDocument: 'Datei',
    kindSticker: 'Sticker',
    kindAnimation: 'GIF',
    kindContact: 'Kontakt',
    kindLocation: 'Standort',
    kindPoll: 'Umfrage',
    kindOther: 'Nachricht',
  },
  es: {
    launcher: 'Soporte',
    title: 'Soporte',
    subtitle: 'Respondemos en menos de un día',
    close: 'Cerrar',
    emptyTitle: 'Aún no hay mensajes',
    emptyText: 'Cuéntanos qué pasó y lo resolvemos.',
    placeholder: '¿Qué pasó?',
    send: 'Enviar',
    attach: 'Adjuntar',
    attachCamera: 'Cámara',
    attachPhoto: 'Foto',
    attachFile: 'Archivo',
    removeFile: 'Quitar',
    fileTooBig: 'El archivo pesa más de 5 MB: elige uno más pequeño',
    sending: 'Enviando',
    sendFailed: 'No se envió. Inténtalo de nuevo',
    blocked: 'Ahora mismo no puedes escribir a soporte.',
    needsPayment: 'El chat de soporte se abre tras tu primera recarga. Recarga y escríbenos.',
    loadOlder: 'Cargar mensajes anteriores',
    loadError: 'No se pudo cargar la conversación',
    retry: 'Reintentar',
    operator: 'Soporte',
    system: 'SHOT',
    download: 'Descargar',
    fileUnavailable: 'El archivo no se abrió',
    sticker: 'Sticker',
    contact: 'Contacto',
    contactNoPhone: 'sin número',
    location: 'Ubicación',
    poll: 'Encuesta',
    unsupported: 'Un mensaje de tipo «{{kind}}»',
    openChat: 'Escribir a soporte',
    kindText: 'Mensaje',
    kindPhoto: 'Foto',
    kindVideo: 'Vídeo',
    kindVideoNote: 'Mensaje de vídeo',
    kindVoice: 'Mensaje de voz',
    kindAudio: 'Audio',
    kindDocument: 'Archivo',
    kindSticker: 'Sticker',
    kindAnimation: 'GIF',
    kindContact: 'Contacto',
    kindLocation: 'Ubicación',
    kindPoll: 'Encuesta',
    kindOther: 'Mensaje',
  },
  pl: {
    launcher: 'Wsparcie',
    title: 'Wsparcie',
    subtitle: 'Odpowiadamy w ciągu doby',
    close: 'Zamknij',
    emptyTitle: 'Na razie nie ma wiadomości',
    emptyText: 'Napisz, co się stało – wszystko wyjaśnimy.',
    placeholder: 'Co się stało?',
    send: 'Wyślij',
    attach: 'Załącz',
    attachCamera: 'Aparat',
    attachPhoto: 'Zdjęcie',
    attachFile: 'Plik',
    removeFile: 'Usuń',
    fileTooBig: 'Plik jest większy niż 5 MB – wybierz mniejszy',
    sending: 'Wysyłam',
    sendFailed: 'Nie wyszło. Spróbuj jeszcze raz',
    blocked: 'Teraz nie możesz pisać do wsparcia.',
    needsPayment: 'Czat ze wsparciem otwiera się po pierwszym doładowaniu. Doładuj konto i pisz.',
    loadOlder: 'Pokaż wcześniejsze wiadomości',
    loadError: 'Nie udało się załadować rozmowy',
    retry: 'Jeszcze raz',
    operator: 'Wsparcie',
    system: 'SHOT',
    download: 'Pobierz',
    fileUnavailable: 'Plik się nie otworzył',
    sticker: 'Naklejka',
    contact: 'Kontakt',
    contactNoPhone: 'brak numeru',
    location: 'Lokalizacja',
    poll: 'Ankieta',
    unsupported: 'Wiadomość typu „{{kind}}”',
    openChat: 'Napisz do wsparcia',
    kindText: 'Wiadomość',
    kindPhoto: 'Zdjęcie',
    kindVideo: 'Wideo',
    kindVideoNote: 'Wideowiadomość',
    kindVoice: 'Wiadomość głosowa',
    kindAudio: 'Audio',
    kindDocument: 'Plik',
    kindSticker: 'Naklejka',
    kindAnimation: 'GIF',
    kindContact: 'Kontakt',
    kindLocation: 'Lokalizacja',
    kindPoll: 'Ankieta',
    kindOther: 'Wiadomość',
  },
});
